import { CartLocalStorageJSON } from '../../common/cart-management/types'
import {
  AUTODELIVERY_RECCURENT_TYPEID,
  CORESITE_LOCALSTORAGE
} from '../../../../utils/constants'

/**
 * Detects the "edit auto delivery" flow by reading the cart directly from
 * localStorage. Reading localStorage directly (rather than the hook state)
 * avoids the SSR hydration timing issue documented in DCXWAM-39033, where
 * `useLocalStorageCart()` can return null/stale data and `resolvedOrderType`
 * may transiently be 'ZAD' on first mount.
 *
 * Returns true when the persisted cart is a recurrent AD order (typeId 'ZAX')
 * or when the AD change-product flag is set.
 */
export const isEditAutoDeliveryCart = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const rawCart = window.localStorage?.getItem(CORESITE_LOCALSTORAGE)
    if (!rawCart) {
      return false
    }

    const cartData = JSON.parse(rawCart) as CartLocalStorageJSON
    return (
      cartData?.cart?.orderType?.typeId === AUTODELIVERY_RECCURENT_TYPEID ||
      cartData?.adChangeProduct === true
    )
  } catch {
    return false
  }
}
